import { get, isNil, set } from "lodash";

export const dataMerge = ({
  localData,
  remoteData,
  localMember,
  remoteMember,
  commonLocalMember,
  commonRemoteMember,
}) => {
  return localData?.map((localEntity) => {
    // The value we will use to match this entity with the remote entity
    const commonKey = get(localEntity, commonLocalMember);
    // If there is no common value in the local entity, skip it
    if (isNil(commonKey)) {
      return localEntity;
    }

    // Find the remote entity with a matching key
    const matchedEntity = remoteData?.find(
      (remoteEntity) => commonKey === get(remoteEntity, commonRemoteMember)
    );
    // If we did not find a remote entity to match with the local one, then skip it
    if (isNil(matchedEntity)) {
      return localEntity;
    }

    // Now set the local member to the value of the desired member in the remote entity
    let updatedEntity = { ...localEntity };
    set(updatedEntity, localMember, get(matchedEntity, remoteMember));
    return updatedEntity;
  });
};

export default dataMerge;
